export const SET_SEARCH_QUERY = "[SEARCH_TOOLS] SET_SEARCH_QUERY";

export const RESET_SEARCH_QUERY = "[SEARCH_TOOLS] RESET_SEARCH_QUERY";
